import {PhoneHQLoader, PhoneHQAvatar} from 'ch3-ui-lib';
import {getUserStatus} from "../../utilis/getStatus.ts";
import {getFullName} from "../../utilis/getFullName.ts";
import {UserElement} from "../../store/features/Users/userService.ts";
import {UserStatus} from "../../store/features/Team/teamService.ts";
import {UserSettings} from "../../store/features/ProfileSettings/profileSettingsService.ts";
import {EncryptedStatus} from "./EncryptedStatus.tsx";

export interface ConversationStartProps {
    usersData: UserElement | UserSettings | null;
    status: UserStatus | null | undefined;
    /** Kept for callers; the profile now opens from the header. */
    setShowInfoPanel: (show: boolean) => void;
}

/**
 * The empty chat before the first message (D-CHAT-02/S03): who the message
 * goes to, centred, and that the chat will be end-to-end encrypted. Status,
 * local time and calling live in the header and the profile panel.
 */
export const ConversationStart = ({usersData, status}: ConversationStartProps) => {
    if (!usersData) {
        return <PhoneHQLoader/>;
    }

    return (
        <div data-testid="chat.new-message.recipient" className="flex h-full flex-col items-center justify-center gap-1.5 text-center">
            <PhoneHQAvatar
                name={usersData.firstName + ' ' + usersData.lastName}
                src={usersData?.avatarUrl}
                size={'64px'}
                status={getUserStatus(status)}
            />
            <div className="mt-1.5 text-lg font-semibold text-ink">
                {getFullName(usersData.firstName, usersData.lastName)}
            </div>
            {usersData.position && <div className="text-[13px] text-ink-muted-strong">{usersData.position}</div>}
            <div className="mt-4">
                <EncryptedStatus isEncrypted={true}/>
            </div>
        </div>
    );
};
